import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";

export default {
  path: "/font",
  redirect: "/font",
  name: "Font",
  component: LAYOUT,
  meta: {
    order: 20,
    title: "字体管理",
  },
  children: [
    {
      path: "",
      name: "FontPage",
      component: () => import("../../views/asset/AssetPage.vue"),
      meta: {
        title: "字体管理",
        icon: "font",
        type: 2,
      },
    },
  ],
} as RouteRecordRaw;
